import IconRightArrow from '@atoms/IconRightArrow';
import { Text, View } from '@components/primitives';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import navigationConstants from '@navigation/navigationConstants';
import { useNavigation } from '@react-navigation/native';
import colors from '@theme/colors';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity } from 'react-native';

function onNotificationsNavigation(navigation: any) {
  return () => navigation.navigate(navigationConstants.NOTIFICATION_SETTINGS);
}

interface ProfileNotificationsProps {
  showNotifications?: boolean;
}

const ProfileNotifications: React.FC<ProfileNotificationsProps> = ({ showNotifications = false }) => {
  const { t } = useTranslation('common');
  const navigation = useNavigation();

  if (!showNotifications) return null;

  return (
    <TouchableOpacity testID="btnProfileNotifications" onPress={onNotificationsNavigation(navigation)}>
      <View flexDirection="row" marginTop="8px" alignItems="center">
        <View
          backgroundColor={colors.secondary.softOrchid}
          paddingX="4px"
          paddingBottom="4.5px"
          paddingTop="3.5px"
          borderRadius="12px"
          justifyContent="center">
          <MaterialCommunityIcons color={colors.secondary.orchid} name="bell" size={24} />
        </View>
        <Text testID="txtProfileNotifications" marginLeft="8px" flex={1} variant="md-normal" alignSelf="center">
          {t('profile.notifications')}
        </Text>
        <IconRightArrow />
      </View>
    </TouchableOpacity>
  );
};

export default ProfileNotifications;
